// extracted by mini-css-extract-plugin
module.exports = {"popup":"details_popup__186fu","item":"details_item__1yEoJ","left":"details_left__2cPrJ","right":"details_right__2fuOc"};